module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "logo-holder"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'performance'
      }
    }
  }, [_vm._v("RADIUS")])], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "user-info",
    class: {
      employee: _vm.employee
    }
  }, [(!_vm.employee) ? _c('div', {
    staticClass: "aff-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$store.state.user.first_name) + " " + _vm._s(_vm.$store.state.user.last_name))])]) : _c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "value-key": "affiliate_id",
      "remoteMethod": _vm.searchAffiliates,
      "placeholder": _vm.affiliate.label || 'Master Affiliate',
      "loading": _vm.affLoading,
      "loading-text": "Loading...",
      "no-data-text": "No Matches",
      "popper-class": "sidebar-select"
    },
    on: {
      "focus": function($event) {
        _vm.searchAffiliates('')
      }
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.selectAffiliate($event)
      }
    },
    model: {
      value: (_vm.affiliate),
      callback: function($$v) {
        _vm.affiliate = $$v
      },
      expression: "affiliate"
    }
  }, _vm._l((_vm.$store.state.cache.affiliateList), function(item) {
    return _c('el-option', {
      key: item.affiliate_id,
      attrs: {
        "label": item.label,
        "value": item
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(item.affiliate_id))])])
  })), _vm._v(" "), _c('h5', {
    staticClass: "aff-id"
  }, [_vm._v(_vm._s(_vm.affiliate.affiliate_id))]), _vm._v(" "), _c('span', {
    staticClass: "divide"
  }), _vm._v(" "), (_vm.manager) ? _c('div', {
    staticClass: "aff-mngr"
  }, [_c('div', {
    staticClass: "aff-mngr-img"
  }, [(_vm.manager.image) ? _c('img', {
    attrs: {
      "src": _vm.manager.image
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aff-mngr-info"
  }, [_c('p', [_vm._v("Affiliate Manager")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.manager.first_name) + " " + _vm._s(_vm.manager.last_name))])])]) : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "navigation-items"
  }, [_c('li', {
    staticClass: "navigation-item",
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'performance'
      }
    }
  }, [_vm._v("Performance")])], 1), _vm._v(" "), _c('li', {
    staticClass: "navigation-item",
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rotator'
      }
    }
  }, [_vm._v("Rotator")])], 1), _vm._v(" "), (_vm.$store.getters.isImpersonated) ? _c('li', {
    staticClass: "navigation-item",
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'setting'
      }
    }
  }, [_vm._v("Settings")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "navigation-item logout-btn",
    on: {
      "click": function($event) {
        _vm.hideMenu() && _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" Logout")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb516d26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = nKhH
// module chunks = 1